import { createAction } from '@reduxjs/toolkit'

import { TWidgetSettingsLoaded } from 'types/GlobalWidget'

// tryUpdateWidget, tryUpdateExportTableWidgets
export const update = createAction('update_widget')
export const updateSuccess = createAction<{
  data: TWidgetSettingsLoaded
  skipFetchData: boolean
}>('update_widget_success')
export const updateFailed = createAction('update_widget_failed')

// invalidateWidgets
export const invalidateWidgets = createAction('invalidate_widgets')
